<template>
  <v-card :color="color" dark style="overflow: scroll">
    <v-card-text>
      <pre :style="{fontSize: `${fontSize}pt`}" v-html="formatedValue"/>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => any,
      required: true,
    },
    fontSize: {
      type: Number,
      required: false,
    },
  },
  computed: {
    color(): string {
      return this.$vuetify.theme.dark ? 'grey darken-4' : 'blue-grey darken-3';
    },
    formatedValue(): string {
      if (this.value && typeof this.value === 'object') {
        try {
          return this.rexHTML(JSON.stringify(this.value, null, 2));
        } catch {
          try {
            return JSON.stringify(this.value, null, 2);
          } catch {
            return this.value;
          }
        }
      }
      try {
        return JSON.stringify(this.value, null, 2);
      } catch {
        return this.value;
      }
    },
  },
  methods: {
    rexHTML(stringValue: any): string {
      return stringValue
          .replace(/(?<=").*?(?=":)/gm, '<span class="purple--text text--lighten-3">$&</span>')
          .replace(/(?<=": )(?!")(true|false)(?=,?)/gm, '<span class="orange--text">$&</span>')
          .replace(/(?<=": )(?!")([+-]?)\d+.\d+(?=,?)/gm, '<span class="light-blue--text">$&</span>');
    },
  },
});
</script>
